<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8">
      <div class="vx-row">
        <div
          v-show="actor.privilege <= 3"
          class="vx-col md:w-1/4 sm:w-1/2 w-full"
        >
          <label class="text-sm opacity-75">Branch</label>
          <v-select
            :disabled="actor.privilege >= 3"
            :options="branchList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.branch"
            class="mb-4 md:mb-0"
          />
        </div>
        <div v-if="actor.privilege < 6" class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Owner (Username)</label>
          <v-select
            @search="searchOwner"
            :options="ownerFilterList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.owner"
          />
        </div>
        <div v-else class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <vs-input
            disabled
            label="Owner"
            class="w-full"
            :value="actor.username"
          />
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">
      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th>No</th>
              <th style="min-width: 120px">Name</th>
              <th style="min-width: 120px">Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in notificationList" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td
                :style="`color: ${
                  checkStatus(item.identifier) ? 'green' : 'red'
                }`"
              >
                {{ checkStatus(item.identifier) ? 'Active' : 'Inactive' }}
              </td>
              <td style="width: 90px">
                <div class="flex">
                  <vx-tooltip
                    :text="checkStatus(item.identifier) ? 'Disable' : 'Enable'"
                    position="top"
                  >
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      :icon="
                        checkStatus(item.identifier) ? 'icon-x' : 'icon-check'
                      "
                      :color="
                        checkStatus(item.identifier) ? 'danger' : 'success'
                      "
                      class="mr-2 vs-con-loading__container"
                      @click="
                        updateStatus(
                          item.identifier,
                          checkStatus(item.identifier)
                        )
                      "
                    ></vs-button>
                  </vx-tooltip>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },

  data() {
    return {
      loading: false,
      data: [],
      token: '',
      actor: {},

      input: {
        status: ''
      },

      notify: 'Server Error',

      notificationList: [],

      notificationListData: [
        {
          name: 'Daily Email',
          identifier: 'daily'
        },
        // {
        //   name: 'Keluar/Masuk POI',
        //   identifier: 'poi'
        // },
        // {
        //   name: 'Power Cut Off',
        //   identifier: 'cut_off'
        // },
        // {
        //   name: 'SOS',
        //   identifier: 'sos'
        // },
        // {
        //   name: 'Maximum Idling',
        //   identifier: 'max_idiling'
        // },
        {
          name: 'Overspeed',
          identifier: 'overspeed'
        },
        // {
        //   name: 'Jatuh Tempo Servis',
        //   identifier: 'servis'
        // },
        // {
        //   name: 'Max Parking',
        //   identifier: 'max_parking'
        // },
        {
          name: 'Driving Behavior',
          identifier: 'driving_behavior'
        },
        {
          name: 'Service Reminder',
          identifier: 'service_reminder'
        },
        {
          name: 'Over Driving',
          identifier: 'over_driving'
        }
      ],

      ownerList: [],
      branchList: [],
      ownerFilterList: [],

      filter: {
        branch: '',
        owner: ''
      }
    }
  },

  computed: {
    filterBranch() {
      return this.filter.branch ? this.filter.branch.value : ''
    },

    filterOwner() {
      return this.filter.owner ? this.filter.owner.value : ''
    }
  },

  watch: {
    filterBranch() {
      this.filter.owner = ''
    },

    filterOwner() {
      this.initTable()
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        this.getBranchList()
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })
  },

  mounted() {},

  methods: {
    getBranchList() {
      this.$http
        .get(`${this.$api.endpoint}/branch/select`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.branchList = res.data.message.data

          this.filter.branch = this.branchList.find((item) => {
            return item.value === this.actor.branch
          })

          if (this.actor.privilege >= 4) {
            this.searchOwner(this.actor.username)
          }
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    searchOwner(search) {
      if (this.actor.privilege == 2 && !this.filter.branch) {
        this.filter.owner = ''
        return
      }

      if (search.length >= 3) {
        this.$http
          .get(`${this.$api.endpoint}/user/owner`, {
            headers: {
              Authorization: `Bearer ${this.token}`
            },
            params: {
              branch:
                this.actor.privilege >= 4
                  ? this.actor.branch_id
                  : this.filter.branch
                  ? this.filter.branch.value
                  : '',
              search: search
            }
          })
          .then((res) => {
            this.ownerFilterList = res.data.message.data

            if (this.actor.privilege >= 4) {
              this.filter.owner = this.ownerFilterList.find((item) => {
                return item.value === this.actor.id
              })

              this.initTable()
            }
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      } else {
        this.ownerFilterList = []
      }
    },

    initTable() {
      if (
        !this.filter.owner ||
        (!this.filter.branch && this.actor.privilege > 1)
      ) {
        this.data = []
        this.notificationList = []
        return
      }

      this.loading = true
      this.$http
        .get(`${this.$api.endpoint}/email_notification`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            user_id: this.filter.owner ? this.filter.owner.value : ''
          }
        })
        .then((res) => {
          this.data = res.data.message.data
          this.notificationList = this.notificationListData
          this.loading = false
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    checkStatus(identifier) {
      const item = this.data.find((l) => {
        return l.identifier === identifier
      })

      // if (item) {
      //   console.log(item.status)
      //   console.log(identifier)
      // }

      return item ? item.status : false
    },

    updateStatus(identifier, status) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `${status ? 'Disable' : 'Enable'} this notification?`,
        text: `Are you sure want to ${
          status ? 'Disable' : 'Enable'
        } this notification ?`,
        accept: () => {
          this.confirm(identifier, status)
        }
      })
    },

    confirm(identifier, status) {
      this.$http
        .post(
          `${this.$api.endpoint}/email_notification/update/${identifier}`,
          {
            status: !status,
            user_id: this.filter.owner ? this.filter.owner.value : ''
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.notify = res.data.message.split('_').join(' ')

          this.initTable()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    }
  }
}
</script>
